import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Gift } from 'lucide-react';
import { Button } from '../ui/button';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Startseite', path: '/' },
    { name: 'Geschenke', path: '/geschenke' },
    { name: 'Ramadan', path: '/ramadan' },
    { name: 'Eid ul Fitr', path: '/eid-ul-fitr' },
    { name: 'Eid ul Adha', path: '/eid-ul-adha' },
    { name: 'Ratgeber', path: '/ratgeber' },
    { name: 'Über uns', path: '/ueber-uns' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#FDFCF8]/95 backdrop-blur-md border-b border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center gap-2 group"
            data-testid="logo-link"
          >
            <div className="w-10 h-10 rounded-full bg-[#4A5D4F] flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
              <Gift className="w-5 h-5 text-white" />
            </div>
            <span className="font-serif text-xl md:text-2xl font-medium text-[#2C332E]">
              EidGeschenke
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.path.replace('/', '') || 'home'}`}
                className={`nav-link text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-[#4A5D4F]'
                    : 'text-[#6B7280] hover:text-[#2C332E]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden text-[#2C332E]"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-[#E5E5E5] animate-fade-in">
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.path.replace('/', '') || 'home'}`}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-3 rounded-xl text-base font-medium transition-colors duration-200 ${
                    isActive(link.path)
                      ? 'bg-[#F5F5F0] text-[#4A5D4F]'
                      : 'text-[#6B7280] hover:bg-[#F5F5F0] hover:text-[#2C332E]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
